import { useWSModal } from "@wingspanhq/fe-component-library";
import { ModalUploadWorkLogAttachment } from "./index";

export const useModalUploadWorkLogAttachment = () =>
  useWSModal(ModalUploadWorkLogAttachment, {
    title: "Upload attachment",
    size: "S"
  });
